import { Player } from "lottie-react";

export default function InformationModal({
  show,
  onClose,
  title = "Success!",
  lottieData,
  buttonText = "Close",
}) {
  if (!show) return null;

  return (
    <div className="fixed inset-0 bg-[#1b3144]/50 backdrop-blur-sm flex items-center justify-center z-50">
      <div className="bg-gradient-to-b from-black/40 via-transparent to-black/40 backdrop-blur border border-white/20 rounded-2xl p-8 max-w-md w-full text-center shadow-lg">
        {lottieData && (
          <Player
            autoplay
            loop={false}
            src={lottieData}
            style={{ height: "120px" }}
          />
        )}

        <h2 className="text-2xl font-semibold mt-4 text-white">
          {title}
        </h2>

        <button
          onClick={onClose}
          className="mt-6 bg-white/20 px-6 py-2 rounded-xl hover:bg-white/30 transition text-white"
        >
          {buttonText}
        </button>
      </div>
    </div>
  );
}
